export default __webpack_public_path__ + "f7438251e7e320a247083c9fc7a4b3c2.png";